import { apiClient, getActivePvzId, isSupabaseConfigured, clearCache } from './_shared.js'

// ============================================
// WORK LOGS (Приёмка / Возвраты / Выданные)
// ============================================

export async function getWorkLogs(type, filters = {}) {
  const pvzId = filters.pvzId || getActivePvzId()
  if (!isSupabaseConfigured) return []
  const params = new URLSearchParams()
  if (type) params.append('type', type)
  if (pvzId) params.append('pvzId', pvzId)
  if (filters.date) params.append('date', filters.date)
  if (filters.startDate) params.append('startDate', filters.startDate)
  if (filters.endDate) params.append('endDate', filters.endDate)
  if (filters.employeeId) params.append('employeeId', filters.employeeId)
  const data = await apiClient('/work-logs?' + params.toString())
  return data.map(item => ({ ...item, work_date: item.work_date?.split('T')[0] }))
}

export async function getWorkLogsAuditLogs(filters = {}) {
  if (!isSupabaseConfigured) return []
  const params = new URLSearchParams()
  if (filters.startDate) params.append('startDate', filters.startDate)
  if (filters.endDate) params.append('endDate', filters.endDate)
  if (filters.limit) params.append('limit', filters.limit)
  return await apiClient('/work-logs/audit-logs?' + params.toString())
}

export async function createWorkLog(type, record) {
  if (!isSupabaseConfigured) return null
  
  const payload = {
    pvz_id: record.pvz_id || getActivePvzId(),
    employee_id: record.employee_id,
    type,
    work_date: record.work_date,
    count: record.count || null,
    box_number: record.box_number || null,
    comment: record.comment || null,
    start_time: record.start_time || null,
    end_time: record.end_time || null,
  }

  const data = await apiClient('/work-logs', {
    method: 'POST',
    body: JSON.stringify(payload)
  })
  
  clearCache('work_logs')
  return data
}

export async function updateWorkLog(id, updates) {
  if (!isSupabaseConfigured) return
  
  const data = await apiClient(`/work-logs/${id}`, {
    method: 'PUT',
    body: JSON.stringify(updates)
  })

  clearCache('work_logs')
  return data
}

export async function requestWorkLogChange(id, requestedData, reason) {
  if (!isSupabaseConfigured) return null
  
  const data = await apiClient(`/work-logs/${id}/request-change`, {
    method: 'POST',
    body: JSON.stringify({ requested_data: requestedData, reason })
  })

  clearCache('work_logs')
  return data
}

export async function getPendingWorkLogChangeRequests(pvzIdParam = null) {
  if (!isSupabaseConfigured) return []
  const pvzId = pvzIdParam || getActivePvzId()
  return await apiClient(`/work-logs/change-requests/pending?pvzId=${pvzId}`)
}

export async function resolveWorkLogChangeRequest(requestId, isApproved, rejectionReason = '') {
  if (!isSupabaseConfigured) return null
  const data = await apiClient(`/work-logs/change-requests/${requestId}/resolve`, {
    method: 'POST',
    body: JSON.stringify({ isApproved, rejectionReason })
  })
  clearCache('work_logs')
  return data
}

export async function deleteWorkLog(id) {
  if (!isSupabaseConfigured) return
  
  await apiClient(`/work-logs/${id}`, {
    method: 'DELETE'
  })

  clearCache('work_logs')
}
